export default "__VITE_ASSET__DXBki4oX__"